import ProjectCard from "../../components/projects/ProjectCard";
import React from "react";
import content from "../../generated/content.json";
import { getMergedProjects } from "../../components/projects/projectsData";
import { useLocale } from "../../i18n/LocaleProvider";
import { useT } from "../../i18n/useT";

const ProjectsIndex = () => {
  const { lang } = useLocale();
  const t = useT();
  const projects = getMergedProjects(lang, content);

  return (
    <section className="container py-5 mt-5">
      <h1 className="mb-4">{t("sections.projects.title")}</h1>
      <div className="row g-4">
        {projects.map((project) => (
          <div className="col-md-6 col-lg-4" key={project.slug}>
            <ProjectCard project={project} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProjectsIndex;
